import React from "react";
import {
  Compass, MapPin, Radio, Users, GraduationCap, Briefcase, Landmark, HeartHandshake,
  ScrollText, Mountain, Palette, Trees, CloudSun, Milestone, Sparkles, Camera, FerrisWheel,
  TentTree, Utensils, CalendarDays, CloudSunRain, Newspaper, TriangleAlert, TrainFront,
  Gavel, MicVocal, Trophy, School, LibraryBig, Backpack, Factory, BriefcaseBusiness, Store,
  Home, Wheat, IdCard, Vote, Building2, HeartPulse, Handshake, Volleyball, Drama, Images,
  BookOpen, FileText, TreePine,
} from "lucide-react";

const MAP = {
  compass: Compass, "map-pin": MapPin, radio: Radio, users: Users,
  "graduation-cap": GraduationCap, briefcase: Briefcase, landmark: Landmark,
  "heart-handshake": HeartHandshake, "scroll-text": ScrollText, mountain: Mountain,
  palette: Palette, trees: Trees, "cloud-sun": CloudSun, milestone: Milestone,
  sparkles: Sparkles, camera: Camera, "ferris-wheel": FerrisWheel, "tent-tree": TentTree,
  utensils: Utensils, "calendar-days": CalendarDays, "cloud-sun-rain": CloudSunRain,
  newspaper: Newspaper, "triangle-alert": TriangleAlert, "train-front": TrainFront,
  gavel: Gavel, "mic-vocal": MicVocal, trophy: Trophy, school: School,
  "library-big": LibraryBig, backpack: Backpack, factory: Factory,
  "briefcase-business": BriefcaseBusiness, store: Store, home: Home, wheat: Wheat,
  "id-card": IdCard, vote: Vote, "building-2": Building2, "heart-pulse": HeartPulse,
  handshake: Handshake, volleyball: Volleyball, drama: Drama, images: Images,
  "tree-pine": TreePine,
};

export function DynIcon({ name, className }) {
  const C = MAP[name] || FileText;
  return <C className={className} />;
}
export { BookOpen };
